import { clsx } from 'clsx';
import Label from '@pixum/label';
import type { FooterProps } from '../../types';
import { LegalListItemLink } from './LegalListItemLink';
import './styles.css';

export const COOKIE_LINK_ID = 'cookie-settings';
export const CANCEL_ORDER_LINK_ID = 'link_footer_service_cancel-order';

/**
 * Creates a legal list section with list and legal list items.
 *
 * The copyright year is now passed as a prop from the server-side Footer component
 * to avoid using `new Date()` in a Client Component during SSR, which would require Suspense.
 *
 * @param props - Footer properties including currentYear.
 * @returns The legal list.
 */
export function LegalList(props: FooterProps) {
  const currentYear = props.currentYear ?? new Date().getFullYear();

  return (
    <section className="footer__legal-list-section" id="legal-list">
      <ul className="footer__legal-list">
        <li className="footer__legal-list-item" key="copyright">
          <Label text={`© Pixum ${currentYear}`} />
        </li>
        {props.notes.map(({ id, internalName, title, url }, index) => (
          <li
            className={clsx('footer__legal-list-item', internalName === CANCEL_ORDER_LINK_ID && 'footer__legal-list-item--bold')}
            key={`${id}-${index}`}
          >
            <LegalListItemLink href={url} id={id} title={title} />
          </li>
        ))}
      </ul>
    </section>
  );
}
